"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowFactory = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var factory_1 = require("../internal/factory");
var transformAlign = function (align) {
    switch (align) {
        case 'center':
            return 'center';
        case 'baseline':
            return 'baseline';
        case 'bottom':
            return 'flex-end';
        default:
            return 'flex-start';
    }
};
exports.RowFactory = factory_1.factory({
    name: 'Row',
    settings: {},
    $when: {},
    component: function () {
        return styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: 100%;\n\n      /* Use flex */\n      display: flex;\n      justify-content: flex-start;\n\n      /* Align accoring to align argument (default to top) */\n      align-items: ", ";\n    "], ["\n      width: 100%;\n\n      /* Use flex */\n      display: flex;\n      justify-content: flex-start;\n\n      /* Align accoring to align argument (default to top) */\n      align-items: ", ";\n    "])), function (p) { return transformAlign(p.align); });
    }
});
var templateObject_1;
